<script setup lang="ts">
import { Method } from 'axios';
import moment from 'moment';
import { useCommonCodeStore } from '~/store/commonCodeStore';

const commonCodeStore = useCommonCodeStore();

const props = withDefaults(defineProps<{
	installInfo: any,
	specInfoType?: string,
}>(), {
	specInfoType: 'normal',
})

const installInfo = computed(() => props.installInfo);
const specInfoType = computed(() => props.specInfoType);

</script>

<template>
	<div class="content">
		<div class="wrapper" v-if="installInfo">
			<div class="content-wrapper">
				<span class="first_letter">주소</span>
				<span>{{ commonUtils.isAllStrDataEmpty(installInfo.equipAddr) + ' ' + commonUtils.isAllStrDataEmpty(installInfo.equipDetailAddr) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">위도</span>
				<span>{{ commonUtils.isAllStrDataEmpty(installInfo.latitude) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">경도</span>
				<span>{{ commonUtils.isAllStrDataEmpty(installInfo.longitude) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">시공업체</span>
				<span>{{ commonUtils.isAllStrDataEmpty(installInfo.equipCompName) }}</span>
			</div>

			<div class="content-wrapper">
				<span class="first_letter">최초 설치일시</span>
				<span>{{ installInfo.constructionDate ? moment(installInfo.constructionDate).format('YYYY-MM-DD') : '-' }}</span>
			</div>

			<div class="content-wrapper" v-if="props.specInfoType !== 'drgeo'">
				<span class="first_letter">사용전 검사일</span>
				<span>{{ installInfo.beforeOpDate ? moment(installInfo.beforeOpDate).format('YYYY-MM-DD') : '-'}}</span>
			</div>
			<div class="content-wrapper" v-if="props.specInfoType !== 'drgeo'">
				<span class="first_letter">설치 확인일</span>
				<span>{{ installInfo.constructionConfirmDate ? moment(installInfo.constructionConfirmDate).format('YYYY-MM-DD') : '-' }}</span>
			</div>
			<div class="content-wrapper">
				<span class="first_letter">모니터링 업체</span>
				<span>{{ commonUtils.isAllStrDataEmpty(installInfo.monitoringCompName) }}</span>
			</div>
			<div class="content-wrapper"  v-if="props.specInfoType !== 'drgeo'">
				<span class="first_letter">모니터링 시작일</span>
				<span>{{ installInfo.moniStartDate ? moment(installInfo.moniStartDate).format('YYYY-MM-DD') : '-' }}</span>
			</div>
			<div class="content-wrapper" v-if="props.specInfoType !== 'drgeo'">
				<span class="first_letter">AS만료일</span>
				<span>{{ installInfo.asExpirationDate ? moment(installInfo.asExpirationDate).format('YYYY-MM-DD') : '-' }}</span>
			</div>
			<div class="content-wrapper" v-if="props.specInfoType !== 'drgeo'">
				<span class="first_letter">계통접속</span>
				<span>{{ commonUtils.isAllStrDataEmpty(installInfo.gridConnectionName) }}</span>
			</div>
		</div>
		<div class="spec-no-data" v-else>설치정보가 존재하지 않습니다.</div>

	</div>

</template>

<style lang="scss" scoped>
@import '@/assets/styles/design-toc/in-equip-card.scss'
</style>